import React, { useEffect } from 'react';
import { RootPage } from '../../pages/RootPage';
import { AppDev } from './dev/AppDev';
import { Api, useApiQuery } from '@orderx/lab/xr/http';
import { toastShowError, toast } from '@orderx/lab/xr/toast';
import { OrderPlacedOverlay } from '../order/placed-overlay/OrderPlacedOverlay';
import { useMe } from '../../hooks/me';
import { AppSystem } from './system/AppSystem';
import { XOverlay } from '../x/overlay/XOverlay';
import { XR } from '@orderx/lab/xr';
import { Kiosk$ } from '../../module/kiosk/Kiosk$';
import { ModuleV2 } from '../../index';
import { OverlayLoading } from '../../module/global/component/OverlayLoading';
import { XSHooks } from '../../xs/hooks';

export function App() {
    XSHooks.useFixColorScheme('dark');

    const { loadUser } = useMe();
    const kiosk = Kiosk$.useDevice();

    const { run, response } = useApiQuery(async () => {
        try {
            await loadUser();
        } catch (error) {
            console.error(error);
        }

        return true;
    });

    useEffect(() => {
        run();

        Api.setOnErrorCallback((error) => {
            console.error(error);

            const message = error?.message || '';

            if (message.includes('ER_')) {
                toastShowError('There has been an error');
            } else if (message.startsWith('could not find')) {
                toastShowError('Entity not found');
            } else if (message.endsWith(' _')) {
                toastShowError(error.message.slice(0, -2));
            } else {
            }
        });
    }, []);

    if (kiosk) {
        return (
            <React.Suspense fallback={<OverlayLoading />}>
                <ModuleV2 />
            </React.Suspense>
        );
    }

    return (
        <>
            <AppSystem />
            <AppDev />
            <toast.ToastContainer limit={1} />

            <XR.App theme={'dark'}>
                <OrderPlacedOverlay />
                {Boolean(response) ? <RootPage /> : <XOverlay type="loading" />}
            </XR.App>
        </>
    );
}
